import { PRICING_GROUPS, PRICING_INTRO, PRICING_META } from "../content/pricing";
import { SELLER } from "../content/legal";
import { LegalFooterLinks } from "./LegalPage";
import SeoHead from "../Components/SeoHead";

export default function Pricing() {
  return (
    <div className="min-h-screen bg-red-50 text-gray-800">
      <SeoHead title={PRICING_META.title} description={PRICING_META.description} path="/pricing" />
      <header className="sticky top-0 z-10 bg-red-50 backdrop-blur border-b">
        <div className="mx-auto max-w-3xl px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Pricing</h1>
          <a href="/" className="text-sm underline hover:no-underline">← Back to Home</a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 space-y-8">
        <section className="rounded-2xl border p-6 shadow-md bg-white">
          <p className="leading-7">{PRICING_INTRO}</p>
        </section>

        {PRICING_GROUPS.map((group) => (
          <section key={group.heading} className="rounded-2xl border p-6 shadow-md bg-white">
            <h2 className="text-lg font-semibold">{group.heading}</h2>
            <p className="mt-2 text-sm text-gray-600">{group.description}</p>
            <table className="mt-4 w-full text-left text-sm">
              <thead>
                <tr className="border-b text-gray-500">
                  <th className="py-2 font-medium">Item</th>
                  <th className="py-2 font-medium text-right">USD</th>
                  <th className="py-2 font-medium text-right">NGN</th>
                </tr>
              </thead>
              <tbody>
                {group.rows.map((r) => (
                  <tr key={r.name} className="border-b last:border-0">
                    <td className="py-3">
                      {r.name}
                      {r.note && <span className="block text-xs text-gray-500">{r.note}</span>}
                    </td>
                    <td className="py-3 text-right font-semibold">{r.usd}</td>
                    <td className="py-3 text-right font-semibold">{r.ngn}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        ))}

        <footer className="py-8 flex flex-col items-center gap-3 text-xs text-gray-500">
          <LegalFooterLinks />
          <p>© {new Date().getFullYear()} {SELLER.tradingName} · A product of {SELLER.legalName}</p>
        </footer>
      </main>
    </div>
  );
}
